import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Redirect } from "react-router-dom";
import {
  Container,
  Box,
  Spinner,
  Center,
  Flex,
  Button,
  Text,
  Link,
} from "@chakra-ui/react";
import { getUser, createUser } from "../../redux/actions/userActions";
import Header from "./Header";
import Vector from "./Vector";
import CustomModal from "./Modal";

const FormCreationPage = (props) => {
  const [showModal, setShowModal] = useState(false);

  const handleOnClick = (e) => {
    e.preventDefault();
    setShowModal((isToggled) => !isToggled);
  };
  const handleOnClose = (e, onClose) => {
    setShowModal((isToggled) => !isToggled);
    onClose();
  };

  const handleFormSubmit = (e, { userEmail, userCountryName }) => {
    e.preventDefault();
    const id = uuidv4();
    const user = { id, email: userEmail, countryName: userCountryName };
    props.dispatchCreateUser(user);
  };
  useEffect(() => {
    props.dispatchGetUser();
  }, []);
  return (
    <Container w="100%" h="100vh" maxW="100%" p="0" bg="#F0F0F1">
      {props.user && props.user.email && props.user.statusCode == 200 && (
        <Redirect to="forms" />
      )}
      {props.status == "loading" ? (
        <Center h="100vh">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Center>
      ) : (
        <>
          {/* header */}
          <Header handleOnClick={handleOnClick} />
          <Box w="100%">
            <Flex align="center" direction="column" h="70vh" justify="center">
              <Vector />
              <Text mt="3">Looks like you haven’t created any forms yet</Text>
              <Text mt="2">
                You can use Freshworks forms to build contact forms, surveys,
                more with just a few clicks.
              </Text>
              <Button
                mt="3"
                colorScheme="primary"
                className="btn--primary"
                size="sm"
                onClick={handleOnClick}
              >
                Add Form
              </Button>
              <Text mt="2">
                Need some help? Check out our{" "}
                <Link color="#2C5CC5" href="#">
                  help article
                </Link>{" "}
              </Text>
            </Flex>
          </Box>
          <CustomModal
            handleOnClose={handleOnClose}
            showModal={showModal}
            handleFormSubmit={handleFormSubmit}
          />
        </>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user.data,
    status: state.user.status,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchGetUser: bindActionCreators(getUser, dispatch),
    dispatchCreateUser: bindActionCreators(createUser, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormCreationPage);
